export default {
  "content": "<path d=\"M20.276 11.946a5.89 5.89 0 01-8.33 8.33L9.872 18.2l1.414-1.414 2.074 2.074a3.89 3.89 0 005.5-5.5l-2.074-2.074L18.2 9.872l2.076 2.074z\" fill=\"#7B61FF\"/><path d=\"M20.707 4.707L13.414 12l3.557 3.557-.708.707-.707.708-3.557-3.557-7.292 7.293-1.414-1.414L10.585 12 7.029 8.444l.708-.707.707-.708L12 10.585l7.293-7.292 1.414 1.414z\" fill=\"#7B61FF\"/><path d=\"M3.725 3.725a5.89 5.89 0 018.329 0L14.128 5.8l-1.414 1.414L10.64 5.14a3.89 3.89 0 00-5.5 5.5l2.074 2.074L5.8 14.128l-2.075-2.074a5.89 5.89 0 010-8.33z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};